/**
 * Utility for managing API request headers
 * Automatically includes developer bypass key when admin mode is active
 * and auth token when user is authenticated
 */

import { getAccessToken } from '../services/authService';

/**
 * Get developer bypass key from localStorage
 * Allows bypassing rate limits when admin mode is activated
 */
export const getDevBypassKey = (): string | null => {
  return localStorage.getItem('devBypassKey');
};

/**
 * Get common headers for API requests (sync version)
 * Includes developer bypass key if available (for rate limit bypass)
 * Note: Does NOT include auth token - use getAPIHeadersWithAuth for that
 */
export const getAPIHeaders = (): HeadersInit => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const devKey = getDevBypassKey();
  if (devKey) {
    headers['x-dev-key'] = devKey;
  }

  return headers;
};

/**
 * Get headers with auth token (async version)
 * Use this for authenticated API calls
 */
export const getAPIHeadersWithAuth = async (): Promise<HeadersInit> => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const devKey = getDevBypassKey();
  if (devKey) {
    headers['x-dev-key'] = devKey;
  }

  const token = await getAccessToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};
